module.exports = __webpack_public_path__ + "img/Tour Breezer.ef53d50d.jpg";